import gift_bow from "../../../assets/images/goldbow.png";
import * as React from "react";
import {FC} from "react";

interface IProps {
    showRibbon: boolean;
}

const GiftBow: FC<IProps> = (props) => {
    return (
        props.showRibbon ? (
            <img src={gift_bow} alt="Gift bow" style={{
                position: "absolute",
                top: -7,
                left: -33,
                width: 150,
                height: "auto",
                transform: "rotate(-45deg)",
                overflow: "hidden",
                zIndex: 3,
                pointerEvents: "none",
            }}/>
        ) : null
    )
}

export default GiftBow;